import { ZuiRadioButton, ZuiRadioButtonGroup } from '@zeiss/zui-react'

export const RadioButton = ({ children, ...props }) => {
    return (
        <ZuiRadioButton environment="desktop" {...props}>
            {children}
        </ZuiRadioButton>
    )
}

export const RadioButtonGroup = ({ children, ...props }) => {
    return <ZuiRadioButtonGroup {...props}>{children}</ZuiRadioButtonGroup>
}
